export default "__VITE_ASSET__CPrXtjSK__"